(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-ga"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-ga"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-ga.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-ga.js":
/*!*******************************!*\
  !*** ./src/mggp-plugin-ga.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 Latest implementation of Google Analitics library. Snippet for asynchronous tracking
 https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApi_gaq#push
 _gaq.push(['_trackEvent', 'button3', 'clicked']);
 */
window._gaq = window._gaq || null;

/**
 * @class MggpPluginGa
 */

var MggpPluginGa = function (_Plugin) {
  _inherits(MggpPluginGa, _Plugin);

  /**
   *
   */
  function MggpPluginGa(player, config) {
    _classCallCheck(this, MggpPluginGa);

    //IE fix
    var _this = _possibleConstructorReturn(this, (MggpPluginGa.__proto__ || Object.getPrototypeOf(MggpPluginGa)).call(this, player, config));

    if (!_this.config && !_this.player) {
      _this.player = arguments[0];
      _this.config = arguments[1];
    }

    _this.namespace = 'ga:';
    _this._timeTrackInterval = null;
    _this._timeTrackDelay = 1000;
    _this._playedSeconds = 0;
    _this._isStarted = false;
    _this._audioTrack = null;
    _this._quality = null;
    _this._prevState = void 0;
    _this._bindPlayer();
    _this._bindAdt();
    _this._bindOther();

    setTimeout(function () {
      return _this._trackStartedInfo();
    }, 100);
    return _this;
  }

  /**
   * Bind player events
   */


  _createClass(MggpPluginGa, [{
    key: '_bindPlayer',
    value: function _bindPlayer() {
      var _this2 = this;

      var player = this.player;

      /*
       *	Reset started flag
       */
      player.on('property:videoInfo', function () {
        _this2._isStarted = false;
        _this2._playedSeconds = 0;
      });

      /*
       * Store previous audio track and track
       */
      player.on('property:audioTrack', function (event) {
        var audioTrack = player.get('videoInfo').audio_tracks[event.data];

        if (audioTrack) {
          if (_this2._audioTrack) {
            _this2._trackPlayer('changeAudioTrack', null, _this2._audioTrack.display_name + '_' + audioTrack.display_name);
          } else {
            _this2._trackPlayer('startAudioTrack', null, audioTrack.display_name);
          }
          _this2._audioTrack = audioTrack;
        }
      });

      /**
       * Store previous quality track and track
       */
      player.on('property:quality', function (event) {
        var quality = event.data;

        if (_this2._quality) {
          _this2._trackPlayer('changeQuality', null, quality + '_' + _this2._quality);
        }

        _this2._quality = quality;
      });

      /**
       * Track player state
       */
      player.on('player:stateChange', function (event) {
        switch (event.data) {
          case 0:
            _this2._trackPlayer('end');
            break;
          case 1:
            // Need to ensure start
            if (!_this2._isStarted) {
              _this2._isStarted = true;
              _this2._trackPlayer('start');
            }
            break;
          case 2:
            _this2._trackPlayer('pause');
            break;
          case 3:
            if (_this2._prevState === 1) {
              _this2._trackPlayer('buffering');
            }
            break;
        }
        _this2._prevState = event.data;
      });

      player.on('player:mediaError', function (event) {
        _this2._trackPlayer('error', event.data.message || '');
      });

      /**
       * Track time update each minute if video is playing
       */
      this._timeTrackInterval = setInterval(function () {
        if (player.get('state') === 1) {
          _this2._playedSeconds++;
          if (_this2._playedSeconds >= 60) {
            _this2._playedSeconds = 0;
            _this2._trackPlayer('playtime');
          }
        }
      }, this._timeTrackDelay);
    }

    /**
     * Bind advertising events
     */

  }, {
    key: '_bindAdt',
    value: function _bindAdt() {
      var _this3 = this;

      // configuration option
      if (this.config.advertising === false) {
        return;
      }

      // Events from AD are implemented insufficiently
      this.player.on('ad:external:startedLoadingNewURL', function (event) {
        _this3._trackAdt('askAdt', event.data.xmlURL, event.data.type, event.data.analyticsTag);
      });

      this.player.on('ad:external:vastEvent', function (event) {
        _this3._trackAdt(event.data.vastEvent, window.location.href, event.data.type, event.data.analyticsTag);
        if (event.data.vastEvent === 'impression') _this3._trackImpression();
      });

      this.player.on('ad:element:needSkip', function () {
        _this3._trackIntersection('zskip');
      });

      this.player.on('ad:playerNeedStop', function () {
        _this3._trackIntersection('zstop');
      });

      this.player.on('ad:external:nobanner', function (event) {
        _this3._trackAdt('nobanner', event.data.mediaURL, event.data.type, event.data.analyticsTag);
      });

      this.player.on('ad:external:vastXMLInvalid', function (event) {
        _this3._trackAdt('vastDocumentNull', event.data.xmlURL, event.data.type, event.data.analyticsTag);
      });

      this.player.on('ad:external:blockStarted', function (event) {
        _this3._trackAdt('askRollblock', event.data.type, '', event.data.analyticsTag);
      });

      this.player.on('ad:external:mediaBeginLoading', function (event) {
        _this3._trackAdt('load', event.data.mediaURL, event.data.type, event.data.analyticsTag);
      });

      this.player.on('ad:external:mediaLoadingTimeout', function (event) {
        _this3._trackAdt('timeOut', event.data.xmlURL, event.data.type, event.data.analyticsTag);
      });

      this.player.on('ad:external:xmlLoadingTimeout', function (event) {
        _this3._trackAdt('xmlTimeout', event.data.xmlURL, 10, event.data.analyticsTag);
      });

      this.player.on('ad:external:closingOnRunningAd', function (event) {
        _this3._trackAdt('forceSkip', event.data.xmlURL, event.data.type, event.data.analyticsTag);
      });
    }
  }, {
    key: '_bindOther',
    value: function _bindOther() {
      var _this4 = this;

      this.player.on('vclicks:hour', function (event) {
        _this4._trackPlayer('VClicks2', window.location.href, event.data, 0);
      });

      this.player.on('apay:notify', function (event) {
        _this4._trackPlayer('ActionPay', window.location.href, _this4.player.get('quality'), 1);
      });

      this.player.on('loader:rebinfo', function (event) {
        _this4._trackPlayer('rebinfo', window.location.href, event.data, 1);
      });

      this.player.on('ga:customEvent', function (event) {
        _this4._push.apply(_this4, ['_trackEvent', event.data[0], event.data[1], event.data[2]]);
      });
    }

    /**
     * Track player events
     * @param  {string} category
     * @param  {string} action
     * @param  {string} label
     */

  }, {
    key: '_trackPlayer',
    value: function _trackPlayer(category, action, label) {
      var videoInfo = this.player.get('videoInfo');
      category = '' + category + (videoInfo.drm_type != "" ? 'DRM' : '') + '_html5';
      var quality = this.player.get('quality') == -1 ? 'Auto' : this.player.get('quality');

      this._push.apply(this, ['_trackEvent', category, this._getURL(), quality]);
    }

    /**
     * Track advertising events
     * @param  {string} category
     * @param  {string} action
     * @param  {string} label
     */

  }, {
    key: '_trackAdt',
    value: function _trackAdt(category, action, label) {
      var analyticsTag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      var videoInfo = this.player.get('videoInfo');

      category = 'adt_' + category + (videoInfo.drm_type != "" ? 'DRM' : '') + '_html5';
      category = category + analyticsTag;

      if (action && typeof action !== 'string') {
        if (action.hasOwnProperty('url')) {
          action = action['url'];
        }
      }

      this._push.apply(this, ['_trackEvent', category, action, label]);
    }

    /**
     * Asynchronous tracking wrapper
     */

  }, {
    key: '_push',
    value: function _push(method) {
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      this.player.utils.log('MggpPluginGA.push(): ' + options[0] + ', ' + options[1] + ', ' + options[2]);
      if (this.config.name) {
        method = this.config.name + '.' + method;
      }

      if (this.config['onGaEvent'] && typeof this.config['onGaEvent'] == 'function') {
        this.config['onGaEvent'](options);
        return;
      }

      if (window._gaq && window._gaq.hasOwnProperty('push')) {
        window._gaq.push([method].concat(options));
      } else {
        if (window.ga && typeof window.ga == 'function') {
          window.ga('send', {
            hitType: 'event',
            eventCategory: options[0],
            eventAction: options[1],
            eventLabel: options[2]
          });
        }
      }
    }
  }, {
    key: '_getURL',
    value: function _getURL() {
      return this.config.host || window.location.href;
    }
  }, {
    key: '_trackStartedInfo',
    value: function _trackStartedInfo() {
      var deepTrackInfo = this.player.get('deepTrackInfo');
      var sizeInfo = this.player.get('sizeInfo');

      if (deepTrackInfo && sizeInfo) {
        this._push.apply(this, ['_trackEvent', 'zt_' + sizeInfo.intersectionRatio.toFixed(1) * 100, deepTrackInfo, String(sizeInfo.boundingClientRect.width + 'x' + sizeInfo.boundingClientRect.height + '-' + sizeInfo.intersectionRect.width + 'x' + sizeInfo.intersectionRect.height + '-' + sizeInfo.intersectionRect.top + '-' + sizeInfo.intersectionRect.left)]);
      }

      if (!deepTrackInfo && sizeInfo) {
        this._push.apply(this, ['_trackEvent', 'zr_' + sizeInfo.intersectionRatio.toFixed(1) * 100, this._getURL(), String(sizeInfo.boundingClientRect.width + 'x' + sizeInfo.boundingClientRect.height + '-' + sizeInfo.intersectionRect.width + 'x' + sizeInfo.intersectionRect.height + '-' + sizeInfo.intersectionRect.top + '-' + sizeInfo.intersectionRect.left)]);
      }

      if (deepTrackInfo && !sizeInfo) {
        this._push.apply(this, ['_trackEvent', "zw_nointer", deepTrackInfo, 0]);
      }

      if (!deepTrackInfo && !sizeInfo) {
        this._push.apply(this, ['_trackEvent', "zq_nointer", this._getURL(), 0]);
      }
    }
  }, {
    key: '_trackIntersection',
    value: function _trackIntersection(type) {
      var deepTrackInfo = this.player.get('deepTrackInfo') || '';
      var sizeInfo = this.player.get('sizeInfo');
      var size = sizeInfo ? String(sizeInfo.boundingClientRect.width + 'x' + sizeInfo.boundingClientRect.height + '-' + sizeInfo.intersectionRect.width + 'x' + sizeInfo.intersectionRect.height + '-' + sizeInfo.intersectionRect.top + '-' + sizeInfo.intersectionRect.left) : '';

      this._push.apply(this, ['_trackEvent', type, deepTrackInfo, size]);
    }
  }, {
    key: '_trackImpression',
    value: function _trackImpression() {
      var deepTrackInfo = this.player.get('deepTrackInfo');
      var sizeInfo = this.player.get('sizeInfo');

      if (sizeInfo) {
        this._push.apply(this, ['_trackEvent', 'zx_' + sizeInfo.intersectionRatio.toFixed(1) * 100, deepTrackInfo, String(sizeInfo.boundingClientRect.width + 'x' + sizeInfo.boundingClientRect.height + '-' + sizeInfo.intersectionRect.width + 'x' + sizeInfo.intersectionRect.height + '-' + sizeInfo.intersectionRect.top + '-' + sizeInfo.intersectionRect.left)]);
      } else {
        this._push.apply(this, ['_trackEvent', 'zx_nointer', deepTrackInfo, this._getURL()]);
      }
    }
    /**
     * On player disposed
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      clearInterval(this._timeTrackInterval);
      this._trackPlayer('close');
    }
  }]);

  return MggpPluginGa;
}(_mggpPlayer.Plugin);

exports.default = MggpPluginGa;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});